import { setup } from "web/entrypoints/common/setup";

import "./baustein-feeds";
import "./css-feeds";
import components from "./react-feeds";

setup(components);
